import { render } from "./ApiKeyModal.vue?vue&type=template&id=72067af6&scoped=true"
import script from "./ApiKeyModal.vue?vue&type=script&lang=js"
export * from "./ApiKeyModal.vue?vue&type=script&lang=js"

import "./ApiKeyModal.vue?vue&type=style&index=0&id=72067af6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72067af6"]])

export default __exports__